import { createFileRoute } from '@tanstack/react-router'
import { SchoolStudentsDevicesClient } from '../components/SchoolStudentsDevicesClient'

export const Route = createFileRoute('/school/$schoolId/devices')({
  head: () => ({
    meta: [{ title: 'Students & Devices | Unbreakable' }],
  }),
  component: SchoolDevicesPage,
})

function SchoolDevicesPage() {
  return <SchoolStudentsDevicesClient initialGroups={[]} />
}
